export const parse = <T extends object>(json: string): T => {
    return JSON.parse(json) satisfies T;
};
